import React from 'react';
// import PropTypes from 'prop-types';
import { Handle, Position } from 'react-flow-renderer';
const _ = {
    forEach:    require('lodash/forEach'),
    find:       require('lodash/find'),
    map:        require('lodash/map'),
};

import ExpandableWell from '../../common/ExpandableWell';
const Globals = require('../../../../../app/globals');

class CompletionNode extends React.Component {
    constructor(props) {
        super(props); // everything from the element
        this.playStore = this.props.data.playStore;
        this.state = this.getStoreState(props);
        this.unsubscribes = [this.playStore.getStore().listen(this.onPlayChange)];
    }

    
//    componentDidMount() {
//        // code to test percent complete arc drawing logic
//        this.testInterval = setInterval(()=>{
//            let percentComplete = (5 + (this.state.percentComplete || 0));
//            if (percentComplete > 100) {
//                percentComplete = 90;
//                // clearInterval(this.testInterval);
//            }
//            this.setState({percentComplete});
//        },1000);
//    }

    componentWillUnmount() {
//        if (this.testInterval) {
//            clearInterval(this.testInterval);
//            delete this.testInterval;
//        }
        this.unsubscribes.forEach(u => u());
    }
	
	getPercentComplete=(gate,min_gate,max_gate,remediating)=>{
        let percentComplete = 100 * ( gate - remediating * 0.5 - min_gate) / Math.max(1,(max_gate - min_gate));
        if (percentComplete < 0) {
            percentComplete = 0;
        }
        else if (percentComplete > 100) {
            percentComplete = 100;
        }
		return percentComplete;
	}

	getStoreState=(props)=>{
		const node_id = props.id;
        let prerequisitesSatisfied = this.playStore.getArePrerequisitesSatisfied(node_id);
		let { gate, min_gate, max_gate, remediating } = this.playStore.getNodeGateStatus(node_id);
		let percentComplete = this.getPercentComplete(gate,min_gate,max_gate,remediating);
		return { gate, min_gate, max_gate, remediating, prerequisitesSatisfied, percentComplete };
	}

    onPlayChange=(storeState)=>{
		this.setState(this.getStoreState(this.props));
    }

    /*renderTargetHandles() {
        if (this.props.data.numTargetHandles < 1) {
            return; // in case we aren't drawing edges 
        }
        
        // render the handles using displacements that don't change if the contents get expanded
        // min-height assumed to be 10 rem. 
        let handles = [];
        let n = this.props.data.numTargetHandles;
        let rem_per_i = (10 / (n+1) );
        for (var i=0; i<n; ++i) {
            let id = `p${i+1}`;
            let rem = ((i+1) * rem_per_i).toFixed(2);
            handles.push(
                // <Handle key={i} type="target" position={Position.Left} id={id} style={{ top: `${rem}rem`, borderRadius: 0 }}/>
                <Handle key={i} type="target" position={Position.Top} id={id} style={{ left: `${rem}rem`, borderRadius: 0 }}/>
            );
        }
        return handles;
    }*/
    
//    renderPointCircle=()=>{
//        return (
//            <div className="point-circle">
//                <svg height="100%" width="100%" viewBox="0 0 100 100">
//                    <circle cx="50" cy="50" r="40" stroke="black" strokeWidth="2" fill="white" />
//                    <text x="50%" y="50%" textAnchor="middle" alignmentBaseline="central">
//                        {`${this.state.percentComplete}%`}
//                    </text>
//                </svg>
//            </div>
//        );
//    }

    renderPercentArc=()=>{
        // console.log(`percentComplete ${this.state.percentComplete} degrees=${(a * 180 / Math.PI).toFixed(1)} x1,y1=(${e1x},${e1y}  x2,y2=(${e2x},${e2y})`);
        let svgElem;
        const strokeColor = "#0E2448";
        const fillColor = "#0E2448";
        if (this.state.percentComplete < 100) {
            const cx = 50;
            const cy = 50;
            const r1 = 30;
            const r2 = 40;
            const xAxisRot = 0;
            const largeArcFlag = (this.state.percentComplete < 50) ? 0 : 1; // small or large arc
            const sweepCW = 1;
            const sweepCCW = 0;
            const a = (Math.PI * 0.5) - 2 * Math.PI * this.state.percentComplete / 100;
            const e1x = cx + Math.cos(a) * r1;
            const e1y = cy - Math.sin(a) * r1;
            const e2x = cx + Math.cos(a) * r2;
            const e2y = cy - Math.sin(a) * r2;
            let path_str =`M${cx} ${cy-r1} L${cx} ${cy-r2} A${r2} ${r2} ${xAxisRot} ${largeArcFlag} ${sweepCW} ${e2x} ${e2y} L${e1x} ${e1y} A${r1} ${r1} ${xAxisRot} ${largeArcFlag} ${sweepCCW} ${cx} ${cy-r1} Z`;
            svgElem=(<path d={path_str} stroke={strokeColor} fill={fillColor} strokeWidth="1"/>);
        }
        else {
            svgElem=(
                <circle cx="50" cy="50" r="35" stroke={strokeColor} strokeWidth={10} fill="none" />
            );
        }

        return (
            <div className="percent-arc">
                <svg height="100%" width="100%" viewBox="0 0 100 100">
                    {svgElem}
                </svg>
            </div>
        );
    }

    render() {
        let nodeClasses = "course-node completion-node";
        let progress_percent = this.state.percentComplete;
        let progress_text = `progress ${Math.floor(progress_percent)}%`;

        let filterStyle;
        if (this.state.prerequisitesSatisfied) {
            nodeClasses += " available";
        }
        else {
            filterStyle = {filter: 'grayscale(100%)'};
        }
        let imgElement;
        if (this.props.data.img_src) {
            imgElement = <img className="node-background" src={this.props.data.img_src} style={filterStyle}/>
        }
        
        return (
            <div className="course-node-trophy-wrapper">
                <div className={nodeClasses}>
                    <h1>{this.props.data.name}</h1>
                    <div className="node-progress-bar" title={progress_text}>
                        <span className="progress" style={{width: `${progress_percent}%`}}/>
                    </div>
                    {imgElement}
                </div>
                <div className="trophy">
                    <img className="corona" src={GlobalConfig.StaticUrl + '/img/courses/course_award_sun.svg'}/>
                    <img className="trophy" src={GlobalConfig.StaticUrl + '/img/courses/trophy.svg'}/>
                    {this.renderPercentArc()}
                    <div className="percent-complete">
                        {`${this.state.percentComplete}%`}
                    </div>
                </div>
            </div>
        );
    }
};

export default CompletionNode;